module.exports = __webpack_public_path__ + "img/itx-file-type-text.c6e4d007.svg";